import {
  IntakeSectionHeader,
  StyledGridCol,
  StyledGridRow,
} from "@/common/styles";
import Button from "@/common/elements/Button";
import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import Modal from "@/common/elements/Modal";
import Table from "@/common/elements/Table";
import { BookingsSectionTitle } from "./styles";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import CommonDatePicker from "@/common/elements/DatePicker";
import { Col, Row } from "react-bootstrap";
import { Checkbox, Form, Popconfirm } from "antd";
import TextField from "@/common/elements/InputElements/TextField";
import TimePicker from "@/common/elements/TimePicker";
import { useDispatch, useSelector } from "react-redux";
import {
  getOptionsFromRefList,
  getRefListNameByID,
  hasCheckSecurity,
  isNonEmptyVariable,
} from "@/util/common_function";
import dayjs from "dayjs";
import { setBookings, setDeleteAPis } from "@/slices/bookingsSlice";
import { v4 as uuidv4 } from "uuid";
import API_ENDPOINTS from "@/util/api";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import {
  MODULES_LIST_WITH_ID,
  SCHEMA_NAME,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";
import { FieldSecurityProvider } from "@/contexts/FieldSecurityContext";
import SecureFormItem from "@/common/SecureFormItem";
import useGridColumnConfig from "@/hooks/useGridColumnConfig";

const MEDICAL_AUTHORIZATIONS_HEADERS = [
  { key: "authorizedBy", text: "Authorized By" },
  { key: "authorizedOn", text: "Authorized On" },
  { key: "expirationDate", text: "Expires On" },
  { key: "comments", text: "Comments" },
];

const MedicalAuthorizationsDetails = forwardRef(
  ({ medicalAuthorizationsDetailsRef, startingPoint = "" }, ref) => {
    const dispatch = useDispatch();
    const { bookings, bookingsFieldsEnabled } = useSelector(
      (state) => state?.bookings
    );
    const [medicalAuth, setMedicalAuth] = useState(
      bookings?.medicalAuthorizations
    );
    useEffect(() => {
      console.log({ medicalAuth });
    }, [medicalAuth]);
    const [showMedicalAuthorizations, setShowMedicalAuthorizations] =
      useState(false);
    const [editMedicalAuth, setEditMedicalAuth] = useState(false);
    const [selectedRow, setSelectedRow] = useState();
    const [originalRow, setOriginalRow] = useState();
    const [medicalId, setMedicalId] = useState(null);
    const [checkedItems, setCheckedItems] = useState({});
    const [medicalAuthForm] = Form.useForm();
    const [isEdit, setisEdit] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const currentUser = JSON.parse(localStorage.getItem("userDetails"));

    // "Config" — drag-reorder/resize columns, persisted per-user (see
    // docs/plans/grid-column-config-feature.md).
    const {
      headers: medicalAuthorizationsHeaders,
      isConfiguring,
      configButtonLabel,
      startConfiguring,
      confirmSave,
      discardChanges,
      dataTableRef,
    } = useGridColumnConfig(
      "Bookings:MedicalAuthorizations",
      MEDICAL_AUTHORIZATIONS_HEADERS
    );

    useEffect(() => {
      if (bookings?.medicalAuthorizations?.length > 0) {
        let updatedAuths = bookings?.medicalAuthorizations.map((auth) => ({
          ...auth,
          medicalAuthorizationID: auth.medicalAuthorizationID
            ? auth.medicalAuthorizationID
            : uuidv4(),
        }));
        setMedicalAuth(updatedAuths);

        let initialCheckedState = {};
        updatedAuths.forEach((auth) => {
          initialCheckedState[auth.medicalAuthorizationID] =
            auth.medicalAuthorizationSpecific
              ? auth.medicalAuthorizationSpecific.reduce((acc, spec) => {
                  acc[spec.authorizationId] = true;
                  return acc;
                }, {})
              : {};
        });
        setCheckedItems(initialCheckedState);
      } else {
        setMedicalAuth([]);
        setCheckedItems({});
      }
    }, [bookings]);

    useEffect(() => {
      console.log({ selectedRow });
      medicalAuthForm.setFieldsValue(selectedRow);
    }, [selectedRow]);

    const handleSpecChange = (authorizationId) => {
      if (!selectedRow) return;
      const currentSpecs = selectedRow.medicalAuthorizationSpecific
        ? [...selectedRow.medicalAuthorizationSpecific]
        : [];
      const index = currentSpecs.findIndex(
        (spec) => spec.authorizationId === Number(authorizationId)
      );
      if (index >= 0) {
        const removedSpec = currentSpecs[index];
        console.log(removedSpec);
        if (removedSpec.medicalAuthorizationSpecificID) {
          const url =
            API_ENDPOINTS.medicalAuthorizationsSpecific +
            removedSpec.medicalAuthorizationSpecificID;
          dispatch(setDeleteAPis(url));
        }
        currentSpecs.splice(index, 1);
      } else {
        let specToAdd = {
          medicalAuthorizationSpecificID: null,
          medicalAuthorizationID: null,
          authorizationId: Number(authorizationId),
        };
        if (originalRow && originalRow.medicalAuthorizationSpecific) {
          const orig = originalRow.medicalAuthorizationSpecific.find(
            (spec) => spec.authorizationId === Number(authorizationId)
          );
          if (orig) {
            specToAdd = orig;
          }
        }
        currentSpecs.push(specToAdd);
      }
      setSelectedRow({
        ...selectedRow,
        medicalAuthorizationSpecific: currentSpecs,
      });
    };

    const handleIsolationChange = (isolationId) => {
      if (!selectedRow) return;
      const currentIsolations = selectedRow.medicalAuthorizationIsolation
        ? [...selectedRow.medicalAuthorizationIsolation]
        : [];
      const index = currentIsolations.findIndex(
        (item) => item.isolationID === Number(isolationId)
      );

      if (index >= 0) {
        const removedIsolation = currentIsolations[index];
        if (removedIsolation.medicalAuthorizationIsolationID) {
          const url =
            API_ENDPOINTS.medicalAuthorizationIsolation +
            removedIsolation.medicalAuthorizationIsolationID;
          dispatch(setDeleteAPis(url));
        }
        currentIsolations.splice(index, 1);
      } else {
        let isolationToAdd = {
          medicalAuthorizationIsolationID: null,
          medicalAuthorizationID: null,
          isolationID: Number(isolationId),
        };
        if (originalRow && originalRow.medicalAuthorizationIsolation) {
          const orig = originalRow.medicalAuthorizationIsolation.find(
            (item) => item.isolationID === Number(isolationId)
          );
          if (orig) {
            isolationToAdd = orig;
          }
        }
        currentIsolations.push(isolationToAdd);
      }
      setSelectedRow({
        ...selectedRow,
        medicalAuthorizationIsolation: currentIsolations,
      });
    };

    const handleAddMedicalAuth = () => {
      const newId = uuidv4();
      medicalAuthForm.resetFields();
      setSelectedRow({
        medicalAuthorizationID: newId,
        medicalAuthorizationSpecific: [],
        medicalAuthorizationIsolation: [],
      });
      setOriginalRow(null);
      setMedicalId(null);
      setShowMedicalAuthorizations(true);
    };

    const closeModal = () => {
      setShowMedicalAuthorizations(false);
      setisEdit(false);
    };

    const handleEditMedicalAuth = (val) => {
      setShowMedicalAuthorizations(true);
      if (val == "edit") {
        setisEdit(true);
      }
    };

    const selectedMedicalRow = (selectedRowData) => {
      const rowId = selectedRowData?.medicalAuthorizationID;
      if (!rowId) {
        console.warn("Warning: Selected row has no ID!", selectedRowData);
      }
      setOriginalRow({ ...selectedRowData });
      setSelectedRow({
        ...selectedRowData,
        medicalAuthorizationID: rowId,
        expireDate: isNonEmptyVariable(selectedRowData?.expirationDate)
          ? dayjs(selectedRowData?.expirationDate)
          : null,
        comments: selectedRowData?.comments || "",
        medicalAuthorizationIsolation:
          selectedRowData?.medicalAuthorizationIsolation || [],
        dateAddedAudit: isNonEmptyVariable(selectedRowData?.dateAdded)
          ? dayjs(`${selectedRowData.dateAdded} ${selectedRowData.timeAdded}`)
          : null,
        creatorStaff: isNonEmptyVariable(selectedRowData?.creatorStaffID)
          ? getRefListNameByID("", selectedRowData?.creatorStaffID, true)
          : "",
      });
      setMedicalId(rowId);
      setEditMedicalAuth(true);
    };

    const handleSave = () => {
      medicalAuthForm
        .validateFields()
        .then((values) => {
          values.expirationDate = isNonEmptyVariable(values.expireDate)
            ? dayjs(values.expireDate).format("MM/DD/YYYY")
            : null;
          values.dateAdded = isNonEmptyVariable(values.dateAddedAudit)
            ? dayjs(values.dateAddedAudit).format("MM/DD/YYYY")
            : null;
          values.timeAdded = isNonEmptyVariable(values.dateAddedAudit)
            ? dayjs(values.dateAddedAudit).format("HH:mm")
            : null;
          values.creatorStaffID = currentUser?.staffId;
          delete values?.expireDate;
          delete values?.dateAddedAudit;

          setCheckedItems((prevCheckedItems) => {
            let updatedData;
            if (medicalId) {
              updatedData = medicalAuth?.map((ma) =>
                ma?.medicalAuthorizationID === medicalId
                  ? {
                      ...ma,
                      ...values,
                      medicalAuthorizationSpecific:
                        selectedRow.medicalAuthorizationSpecific || [],
                      medicalAuthorizationIsolation:
                        selectedRow.medicalAuthorizationIsolation || [],
                    }
                  : ma
              );
            } else {
              updatedData = [
                ...medicalAuth,
                {
                  ...values,
                  medicalAuthorizationID: selectedRow.medicalAuthorizationID,
                  medicalAuthorizationSpecific:
                    selectedRow.medicalAuthorizationSpecific || [],
                  medicalAuthorizationIsolation:
                    selectedRow.medicalAuthorizationIsolation || [],
                },
              ];
            }
            updateBookings(updatedData);
            setShowMedicalAuthorizations(false);
            setEditMedicalAuth(false);
            return prevCheckedItems;
          });
        })
        .catch((err) => console.log("Validation error:", err));
    };

    const updateBookings = (tb) => {
      console.log("Updating bookings with:", tb);
      const uuidRegex =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
      const updatedMedicalAuthorizations = tb.map((auth) => {
        const actualAuthID = uuidRegex.test(auth.medicalAuthorizationID)
          ? null
          : auth.medicalAuthorizationID;
        return {
          ...auth,
          medicalAuthorizationID: actualAuthID || null,
          medicalAuthorizationSpecific: auth.medicalAuthorizationSpecific || [],
          medicalAuthorizationIsolation:
            auth.medicalAuthorizationIsolation || [],
        };
      });
      console.log(
        "Updated medicalAuthorizations:",
        updatedMedicalAuthorizations
      );
      dispatch(
        setBookings({
          medicalAuthorizations: updatedMedicalAuthorizations,
        })
      );
    };

    useImperativeHandle(medicalAuthorizationsDetailsRef, () => ({
      submitForm: () => medicalAuthForm.submit(),
      resetForm: () => medicalAuthForm.resetFields(),
      getFormValues: () => {
        return medicalAuthForm.getFieldsValue();
      },
      getFieldsError: () => medicalAuthForm.getFieldsError(),
      isFieldsValidating: () => medicalAuthForm.isFieldsValidating(),
      validateFields: () => medicalAuthForm.validateFields(),
    }));

    useEffect(() => {
      if (isEdit) {
        let isShow = hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.subModule,
          LABELS_CAPITAL.MODIFY,
          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
          SUB_MODULES_LIST_WITH_ID.Inmate_Medical
        );
        if (isShow) {
          setIsDisabled(false);
        } else {
          setIsDisabled(true);
        }
      } else {
        setIsDisabled(false);
      }
    }, [isEdit]);

    useEffect(() => {
      console.log({ isDisabled });
    }, [isDisabled]);

    return (
      <>
        <StyledGridRow justify={"space-between"}>
          <StyledGridCol>
            <Button
              onClick={handleAddMedicalAuth}
              disabled={
                !bookingsFieldsEnabled ||
                isConfiguring ||
                !hasCheckSecurity(
                  Security_Types.functionality,
                  Entity_types.subModule,
                  LABELS_CAPITAL.ADD,
                  MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                  SUB_MODULES_LIST_WITH_ID.Inmate_Medical
                )
              }
            >
              ADD
            </Button>
          </StyledGridCol>
          <StyledGridCol>
            <Button
              style={{ marginRight: "10px" }}
              disabled={
                !editMedicalAuth ||
                isConfiguring ||
                !hasCheckSecurity(
                  Security_Types.functionality,
                  Entity_types.subModule,
                  LABELS_CAPITAL.VIEW,
                  MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                  SUB_MODULES_LIST_WITH_ID.Inmate_Medical
                )
              }
              onClick={() => handleEditMedicalAuth("edit")}
            >
              Details
            </Button>

            {/* Config — drag-reorder/resize columns */}
            {!isConfiguring ? (
              <Button htmlType="button" onClick={startConfiguring}>
                {configButtonLabel}
              </Button>
            ) : (
              <Popconfirm
                title="Do you want to save the current list view configuration?"
                onConfirm={confirmSave}
                onCancel={discardChanges}
                okText="Yes"
                cancelText="No"
              >
                <Button htmlType="button">{configButtonLabel}</Button>
              </Popconfirm>
            )}
          </StyledGridCol>
        </StyledGridRow>

        <Modal
          header={"Medical Authorizations"}
          show={showMedicalAuthorizations}
          size="xl"
          onHide={closeModal}
          footerActions={[
            {
              key: "save",
              text: "Save",
              onClick: handleSave,
              disabled: isDisabled || !bookingsFieldsEnabled,
            },
          ]}
          footerCloseAction={() => setisEdit(false)}
          footerCloseActionText="Close"
        >
          {/* FieldSecurityProvider wraps the entire modal Form */}
          <FieldSecurityProvider
            entity={SCHEMA_NAME.MEDICAL_AUTHORIZATIONS}
            startingPoint={startingPoint}
            bookingsFieldsEnabled={bookingsFieldsEnabled}
          >
            <Form form={medicalAuthForm}>

              {/* ── Authorization Information ───────────────────────── */}
              <BookingsSectionTitle style={{ marginBottom: "10px", marginTop: "15px" }}>
                <span>Authorization Information</span>
              </BookingsSectionTitle>
              <StyledGridRow gutter={16}>
                <StyledGridCol lg={6}>
                  <SecureFormItem
                    fieldName="expireDate"
                    formItemProps={{ name: "expireDate", label: "Expiration Date" }}
                  >
                    <CommonDatePicker format="MM/DD/YYYY" showTime={false} />
                  </SecureFormItem>
                </StyledGridCol>
              </StyledGridRow>

              {/* ── Specific Authorizations ─────────────────────────── */}
              <BookingsSectionTitle style={{ marginBottom: "10px", marginTop: "15px" }}>
                <span>Specific Authorization(s)</span>
              </BookingsSectionTitle>
              <StyledGridRow>
                {getOptionsFromRefList("Medical_Authorizations", false, false, true).map(
                  (medical, i) => {
                    const isChecked = selectedRow?.medicalAuthorizationSpecific
                      ? selectedRow.medicalAuthorizationSpecific.some(
                          (spec) => spec.authorizationId === Number(medical.value)
                        )
                      : false;
                    if (i !== 0)
                      return (
                        <StyledGridCol span={6} key={medical.value}>
                          {/* Checkboxes are controlled via state, not form fields — plain FormItem */}
                          <FormItem
                            label={medical.label}
                            layout="horizontal"
                            labelPostion="label-right"
                          >
                            <Checkbox
                              checked={isChecked}
                              onChange={() => handleSpecChange(medical.value)}
                              disabled={!bookingsFieldsEnabled}
                            />
                          </FormItem>
                        </StyledGridCol>
                      );
                  }
                )}
              </StyledGridRow>

              {/* ── Isolation Authorizations ────────────────────────── */}
              <BookingsSectionTitle style={{ marginBottom: "10px", marginTop: "15px" }}>
                <span>Isolation Authorization(s)</span>
              </BookingsSectionTitle>
              <StyledGridCol>
                <StyledGridRow gutter={16}>
                  {getOptionsFromRefList("Medical_Isolation", false, false, true).map(
                    (med, i) => {
                      const isChecked = selectedRow?.medicalAuthorizationIsolation
                        ? selectedRow.medicalAuthorizationIsolation.some(
                            (item) => item.isolationID === Number(med.value)
                          )
                        : false;
                      if (i !== 0)
                        return (
                          <StyledGridCol span={8} key={med.value}>
                            {/* Checkboxes are controlled via state, not form fields — plain FormItem */}
                            <FormItem
                              label={med.label}
                              layout="horizontal"
                              labelPostion="label-right"
                            >
                              <Checkbox
                                checked={isChecked}
                                onChange={() => handleIsolationChange(med.value)}
                                disabled={!bookingsFieldsEnabled}
                              />
                            </FormItem>
                          </StyledGridCol>
                        );
                    }
                  )}
                </StyledGridRow>
              </StyledGridCol>

              {/* ── Comments ────────────────────────────────────────── */}
              <Col span={8}>
                <SecureFormItem
                  fieldName="comments"
                  formItemProps={{ name: "comments", label: "Comments" }}
                >
                  <TextField
                    inputType="textarea"
                    as="textarea"
                    id="description"
                    name="description"
                    variant="outlined"
                    rows="5"
                  />
                </SecureFormItem>
              </Col>

              {/* ── Administrative Information ───────────────────────── */}
              <IntakeSectionHeader>
                <span>Administrative Information</span>
              </IntakeSectionHeader>
              <StyledGridRow gutter={16}>
                <StyledGridCol lg={3}>
                  {/* Always read-only — plain FormItem */}
                  <FormItem label="ID" layout="vertical" name="medicalAuthorizationId">
                    <TextField disabled />
                  </FormItem>
                </StyledGridCol>
                <StyledGridCol lg={4}>
                  <SecureFormItem
                    fieldName="dateAddedAudit"
                    formItemProps={{ name: "dateAddedAudit", label: "Date Entered", layout: "vertical" }}
                  >
                    <CommonDatePicker id="dateEntered" />
                  </SecureFormItem>
                </StyledGridCol>
                <StyledGridCol lg={6}>
                  {/* Always read-only — plain FormItem */}
                  <FormItem label="User" layout="vertical" name="creatorStaff">
                    <TextField disabled />
                  </FormItem>
                </StyledGridCol>
              </StyledGridRow>

            </Form>
          </FieldSecurityProvider>
        </Modal>

        {hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.subModule,
          LABELS_CAPITAL.VIEW,
          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
          SUB_MODULES_LIST_WITH_ID.Inmate_Medical
        ) && (
          <Table
            ref={dataTableRef}
            headers={medicalAuthorizationsHeaders}
            draggable={isConfiguring}
            data={medicalAuth?.map((auth) => ({
              medicalAuthorizationID: auth.medicalAuthorizationID,
              expirationDate: auth?.expirationDate || "",
              comments: auth?.comments || "",
              medicalAuthorizationSpecific: auth.medicalAuthorizationSpecific,
              medicalAuthorizationIsolation: auth.medicalAuthorizationIsolation,
              dateAdded: auth.dateAdded,
              timeAdded: auth.timeAdded,
              medicalAuthorizationId: auth?.medicalAuthorizationID,
              creatorStaffID: auth?.creatorStaffID,
            }))}
            onRowClick={(data) => selectedMedicalRow(data)}
            onRowDoubleClick={(value) => {
              selectedMedicalRow(value);
              handleEditMedicalAuth("edit");
            }}
            style={{ marginTop: "15px" }}
            selected={selectedRow === null}
          />
        )}
      </>
    );
  }
);

export default MedicalAuthorizationsDetails;